// CSED Complete Taxonomy - 3 Pillars, 21 Themes, 105 Sub-themes

export const TAXONOMY = {
  "Economic Stability": {
    "Enterprise Stability & Revival": [
      "MSME Distress Diagnostics",
      "Non-Financial Causes of Enterprise Failure",
      "Turnaround Strategies for Viable Enterprises",
      "Business Model Restructuring",
      "Operational Efficiency Frameworks"
    ],
    "Governance & Institutional Capacity": [
      "Corporate Governance in MSMEs",
      "Board Effectiveness in Mid-sized Firms",
      "Institutional Decision-Making Frameworks",
      "Risk Governance Models",
      "Leadership & Management Capability Gaps"
    ],
    "Capital Efficiency & Deployment": [
      "Capital Allocation Effectiveness",
      "Debt vs Equity Structuring Challenges",
      "Institutional Capital Deployment Gaps",
      "Blended Finance Models",
      "Credit Access & Financial Inclusion for Enterprises"
    ],
    "Regional Economic Systems": [
      "Regional Industrial Ecosystem Development",
      "Cluster-Based Economic Models",
      "Tier-2 & Tier-3 Economic Strengthening",
      "Local Value Chain Development",
      "Regional Competitiveness Frameworks"
    ],
    "Supply Chain & Industrial Resilience": [
      "Supply Chain Fragility & Risk",
      "Decentralised Production Models",
      "Import Dependency Risks",
      "Logistics & Infrastructure Bottlenecks",
      "Industrial Diversification Strategies"
    ],
    "Employment & Livelihood Stability": [
      "Employment Impact of Enterprise Distress",
      "Informal vs Formal Workforce Dynamics",
      "Job Retention Strategies",
      "Skill-Economy Alignment",
      "Labour Productivity & Sustainability"
    ],
    "Policy & Regulatory Interface": [
      "Ease of Doing Business – Ground Realities",
      "Regulatory Frictions in MSMEs",
      "Policy Design vs Implementation Gaps",
      "Industrial Policy Effectiveness",
      "Compliance Burden Analysis"
    ]
  },
  "Social Equity": {
    "Monitoring & Evaluation": [
      "Impact Measurement Frameworks",
      "Outcome vs Output-Based Evaluation",
      "Real-Time Monitoring Systems",
      "Data Integrity & Validation Mechanisms",
      "Third-Party Evaluation Models"
    ],
    "Institutional Capacity Building": [
      "NGO Governance Frameworks",
      "Financial Compliance Systems",
      "Program Design Effectiveness",
      "Operational Capability Strengthening",
      "Institutional Maturity Models"
    ],
    "CSR & Institutional Capital Efficiency": [
      "CSR Fund Utilisation Effectiveness",
      "Strategic CSR vs Compliance CSR",
      "Capital Allocation Frameworks",
      "Impact Assurance Models",
      "Risk Mitigation in Social Investments"
    ],
    "Transparency & Accountability": [
      "Financial Transparency Mechanisms",
      "Governance Audits",
      "Accountability Frameworks for NGOs",
      "Anti-Misallocation Systems",
      "Public Trust Architecture"
    ],
    "Development Outcomes & Impact": [
      "Measuring Social Impact at Scale",
      "Outcome Attribution Challenges",
      "Long-Term vs Short-Term Impact",
      "Beneficiary vs System-Level Impact",
      "Evidence-Based Development Models"
    ],
    "Sector-Specific Social Systems": [
      "Education Systems Effectiveness",
      "Public Health Delivery Systems",
      "Rural Development Models",
      "Urban Social Infrastructure",
      "Livelihood & Skill Development Systems"
    ],
    "State-Institution-NGO Interface": [
      "Public-Private Development Models",
      "Government Scheme Effectiveness",
      "Implementation Gaps in Welfare Programs",
      "Multi-Stakeholder Coordination",
      "Institutional Trust Deficit"
    ]
  },
  "Environmental Resilience": {
    "Climate Risk & Economic Impact": [
      "Climate Risk Diagnostics for Enterprises",
      "Sectoral Climate Vulnerability",
      "Climate-Induced Economic Disruptions",
      "Risk Pricing & Financial Implications",
      "Climate Stress Testing for Institutions"
    ],
    "Circular Economy Systems": [
      "Resource Efficiency Frameworks",
      "Waste-to-Value Models",
      "Circular Business Models for MSMEs",
      "Industrial Symbiosis",
      "Material Flow Optimisation"
    ],
    "Natural Resource Management": [
      "Water Stress & Economic Impact",
      "Land Use & Industrialisation",
      "Energy Security & Transition",
      "Resource Scarcity Risks",
      "Sustainable Resource Governance"
    ],
    "Supply Chain Environmental Risk": [
      "Climate-Sensitive Supply Chains",
      "Carbon Footprint in Value Chains",
      "Sustainable Procurement Models",
      "ESG Integration in Supply Chains",
      "Logistics & Environmental Efficiency"
    ],
    "Urbanisation & Spatial Imbalance": [
      "Urban Concentration Risks",
      "Tier-2 & Tier-3 Development Models",
      "Migration & Economic Pressure",
      "Infrastructure Stress",
      "Decentralised Growth Strategies"
    ],
    "Climate Adaptation & Resilience": [
      "MSME Climate Preparedness",
      "Local Economy Adaptation Models",
      "Disaster Resilience Frameworks",
      "Cross-Sector Coordination Systems",
      "Resilient Infrastructure Planning"
    ],
    "Policy & Governance for Sustainability": [
      "Environmental Policy Effectiveness",
      "ESG Frameworks & Implementation",
      "Regulatory Mechanisms for Sustainability",
      "Carbon Markets & Incentives",
      "Institutional Integration of Sustainability"
    ]
  }
};

// Get all pillars
export const getPillars = () => Object.keys(TAXONOMY);

// Get themes for a specific pillar
export const getThemes = (pillar) => {
  return pillar && TAXONOMY[pillar] ? Object.keys(TAXONOMY[pillar]) : [];
};

// Get sub-themes for a specific theme under a pillar
export const getSubThemes = (pillar, theme) => {
  return pillar && theme && TAXONOMY[pillar] && TAXONOMY[pillar][theme] 
    ? TAXONOMY[pillar][theme] 
    : [];
};

// Get all themes across all pillars
export const getAllThemes = () => {
  const themes = [];
  Object.keys(TAXONOMY).forEach(pillar => {
    Object.keys(TAXONOMY[pillar]).forEach(theme => {
      themes.push({ pillar, theme });
    });
  });
  return themes;
};
